import React from "react";
import {Card, CardBody} from "reactstrap";

import cabfareLogo from "../../../assets/img/cabfare/cabfare-logo.png";

// Card chrome shared by the MFA screens so enrolment / challenge / email-link
// all look like the rest of the auth flow (cf. ExtSignIn).
const ExtMfaShell = (props) => (
  <React.Fragment>
    <div className="text-center mt-4">
      { !!props.title && (<h1 className="h2">{props.title}</h1>) }
      { !!props.lead && (<p className="lead">{props.lead}</p>) }
    </div>
    <Card>
      <CardBody>
        <div className="m-sm-4">
          <div className="text-center">
            <img
              src={cabfareLogo}
              alt="Cabfare"
              className="img-fluid"
              width="300"
              style={{marginBottom: '2rem'}}
            />
          </div>
          {props.children}
        </div>
      </CardBody>
    </Card>
  </React.Fragment>
);

export default ExtMfaShell;